import React from 'react';
import AusenciasPage from './ausencias/AusenciasPage';

const PermisosPage = () => <AusenciasPage tipo="permiso" />;

export default PermisosPage;
